import { api } from "./api";

const COINGECKO =
  "https://api.coingecko.com/api/v3";

const ETHERSCAN =
  "https://api.etherscan.io/api";

export async function getPrices() {
  return api<any>(
    `${COINGECKO}/simple/price?ids=ethereum,arbitrum,blast&vs_currencies=usd`
  );
}

export async function getEthereumBlock() {
  return api<any>(
    `${ETHERSCAN}?module=proxy&action=eth_blockNumber&apikey=${process.env.REACT_APP_ETHERSCAN_KEY}`
  );
}

export async function getGasOracle() {
  return api<any>(
    `${ETHERSCAN}?module=gastracker&action=gasoracle&apikey=${process.env.REACT_APP_ETHERSCAN_KEY}`
  );
}